import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Select as ChakraSelect,
  SelectProps as ChakraSelectProps,
  useColorModeValue,
} from '@chakra-ui/react';
import { forwardRef, ForwardRefRenderFunction } from 'react';
import { FieldError } from 'react-hook-form';

interface SelectProps extends ChakraSelectProps {
  name: string;
  label?: string;
  error?: FieldError;
}

const SelectBase: ForwardRefRenderFunction<HTMLSelectElement, SelectProps> = (
  { name, label, error = null, ...rest },
  ref,
) => {
  const color = useColorModeValue('gray.700', 'white');
  const colorInput = useColorModeValue('gray.700', 'white');

  return (
    <FormControl isInvalid={!!error}>
      {!!label && (
        <FormLabel
          color={color}
          fontSize="sm"
          fontWeight="light"
          htmlFor={name}
        >
          {label}
        </FormLabel>
      )}

      <ChakraSelect
        id={name}
        name={name}
        ref={ref}
        fontWeight="light"
        fontSize="md"
        color={colorInput}
        size="lg"
        rounded="2xl"
        {...rest}
      />

      {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  );
};

export const Select = forwardRef(SelectBase);
